// extracted by mini-css-extract-plugin
export default {"wrapper":"Accounts_wrapper__Vw6nq","emptyList":"Accounts_emptyList__gIGUF","iconHistory":"Accounts_iconHistory__R3a96","icon":"Accounts_icon__CU6nz"};